import React, { PropsWithChildren } from "react";

import MediaQuery from "react-responsive";
import { ScreenSize } from "./Responsive.types";

/**
 * It renders components when user screen size is below 767px.
 * @param SmallScreen props.
 * @returns Component optimized for small screen.
 */
export const SmallScreen = (props: PropsWithChildren<{}>) => <MediaQuery maxWidth={ScreenSize.Small}>{props.children}</MediaQuery>;
